import {Component} from '@angular/core';
import {NavParams} from 'ionic-angular';

import {Termin} from '../../model/termin';

import {isAnyPropertySet} from '../../util/util';

import { SterbefallProvider } from '../../providers/sterbefall.provider';


/**
 * Seite zum Bearbeiten oder Anlegen eines Termins.
 * Zum Bearbeiten muss der Index des Termins im Parameter "termin-index"
 * gegeben sein. Fehlt er, wird ein neuer Termin angelegt und beim Verlassen
 * der Seite gespeichert (sofern Daten hinterlegt sind).
 * Beim Verlassen werden außerdem die Termine nach aufsteigendem Zeitpunkt sortiert.
 *
 * @author Andreas Wenger
 */
@Component({
	templateUrl: 'termin.html'
})
export class TerminPage {

	termin: Termin;
	isNew: boolean;

	constructor(navParams: NavParams, public sterbefallProvider : SterbefallProvider) {
		let index = navParams.get('termin-index');
		this.isNew = (index == undefined);
		if (this.isNew)
			this.termin = new Termin();
		else
			this.termin = sterbefallProvider.aktuellerSterbefall.termine[index];
	}

	ionViewWillLeave() {
		let termine = this.sterbefallProvider.aktuellerSterbefall.termine;
		if (this.isNew && isAnyPropertySet(this.termin))
			termine.push(this.termin);
		//Nach aufsteigendem Zeitpunkt sortieren
		termine.sort((a, b) => {
			let datum = a.datum.localeCompare(b.datum);
			if (datum != 0)
				return datum;
			let uhrzeit = a.uhrzeit.localeCompare(b.uhrzeit);
			return uhrzeit;
		});
	}

}



// WEBPACK FOOTER //
// ./src/pages/termin/termin.ts